// extracted by mini-css-extract-plugin
export default {"noNumberSpinner":"AccountingPage_noNumberSpinner__Z0-R4"};